import UseScrollAnimation from "../Elements/ScrollAnimation";
// import ThreeTestimonials from "./Page_Sections/threeTestimonials";
// import AboutThePractitioner from "./Page_Sections/aboutThePractitioner";

const sections = [
  {
    h: "Acceptance of Terms",
    p: "By accessing this website or scheduling services with The Wellness Destination Homeopathy, LLC, you agree to be bound by these Terms and Conditions.",
  },
  {
    h: "Scope of Services",
    p: "Services are provided as classical homeopathic consultations. They are complementary in nature and are not intended to replace conventional medical diagnosis or healing.",
  },
  {
    h: "Appointments & Cancellations",
    p: "Please provide at least 24 hours' notice for cancellations. Late cancellations or no-shows may be subject to a fee.",
  },
  {
    h: "Payment",
    p: "Payment is due at the time of service unless otherwise arranged. We accept major credit cards and electronic payment.",
  },
  {
    h: "Confidentiality",
    p: "All information shared during consultations is kept confidential, in accordance with our Privacy Policy and applicable professional standards.",
  },
  {
    h: "Intellectual Property",
    p: "All content on this website — text, images, logo, and design — is the property of The Wellness Destination Homeopathy, LLC and may not be reused without written permission.",
  },
  {
    h: "Limitation of Liability",
    p: "To the fullest extent permitted by law, The Wellness Destination Homeopathy, LLC shall not be liable for any indirect, incidental, or consequential damages arising from the use of this website or services.",
  },
  {
    h: "Governing Law",
    p: "These terms are governed by the laws of the state in which the practice operates, without regard to conflict-of-law principles.",
  },
];

const TermsAndConditions = () => {
  UseScrollAnimation(); // ✅ just call it

  return (
    <>
      <div className="HomeParent">
        <div className="HomeBox ">
          <section className="Disclaimer_Section">
            <div className="Disclaimer_SectionBox">
              <div className="Disclaimer_Section_TitleHeadingContent">
                <p className="Disclaimer_Section_Title animate-top">
                  Terms and Conditions
                </p>
                <span className="Disclaimer_Section_Heading animate-top">
                  Working together, <br />
                  with clarity.
                </span>
                <p className="Disclaimer_Section_Content animate-top">
                  {`Last updated: ${new Date().getFullYear()}`}
                </p>
              </div>
            </div>
          </section>

          <section className="Disclaimer_Section00">
            <div className="Disclaimer_SectionParent00">
              {sections.map((s) => (
                <div>
                  <div className="Disclaimer_SectionBox00">
                    <h2 className="Disclaimer_Section_Heading00 animate-top">
                      {s.h}
                    </h2>
                    <p className="Disclaimer_Section_Content00 animate-top">
                      {s.p}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>
          {/* <ThreeTestimonials /> */}

          {/* <AboutThePractitioner /> */}
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
